export default __webpack_public_path__ + "static/media/promo-28-degrees.c044082e.png";